import React, { useState } from 'react'
import {
  Box, Divider,
  Grid,
  IconButton,
  ImageListItem,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material'
import styles from './styles'
import CloseIcon from '@mui/icons-material/Close'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { SavedArticle } from '../../type/article'
import { EntitlementArticle } from '../../../../../common/interfaces/EntitlementArticle'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import DeleteArticleModal from '../dialog/DeleteArticleModal'

type DrawerDetailsProps = {
  onClick: (open: boolean) => void
  deleteArticles: (article: EntitlementArticle[], callback: () => void) => void
  openIssue: (id: string, updateOpenIssue: boolean, articleId: string) => void
  article: SavedArticle
}

const DrawerDetails = (props: DrawerDetailsProps) => {
  const { article, onClick, openIssue, deleteArticles } = props
  const [showDelete, setShowDelete] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedArticles, setSelectedArticles] = useState<EntitlementArticle>()

  const onEditSaveArticleClicked = () => {
    setShowDelete(!showDelete)
  }

  const handleDelete = (article: EntitlementArticle) => {
    setShowDeleteModal(true)
    setSelectedArticles(article)
  }

  const onConfirm = () => {
    selectedArticles && deleteArticles([selectedArticles], onClose)
  }

  const onClose = () => {
    setShowDeleteModal(false)
  }

  const onCancel = () => {
    setShowDeleteModal(false)
  }

  const renderDeleteSection = (article: EntitlementArticle) => {
    return (
      <Box style={{ ...styles.deleteContainer, height: 60 }}>
        <Box style={styles.trash}>
          <DeleteIcon fontSize={'large'} style={{ color: 'red'}} onClick={() => handleDelete(article)}/>
          <Typography style={styles.largeText}>&nbsp;Trash</Typography>
        </Box>
      </Box>

    )
  }

  return (
    <Box role="presentation">
      <DeleteArticleModal
        visible={showDeleteModal}
        onConfirm={onConfirm}
        onCancel={onCancel}
        text={selectedArticles ? `You are about to trash 1 saved articles` : ''}
      />
      <List>
        <IconButton onClick={() => onClick(false)} style={styles.closeIcon}>
          <CloseIcon />
        </IconButton>
        <Box sx={{ p: 1.5 }} />
        <Grid sx={styles.drawerContainer}>
          <Typography style={styles.drawerHeader}>Saved Articles</Typography>
          <Box onClick={() => onClick(false)} style={styles.subTitleContainer}>
            <ArrowBackIcon fontSize={'small'}/>
            <Typography style={styles.drawerSubheader}>  back to Magazines</Typography>
          </Box>
        </Grid>
        <Divider />
        <Grid sx={{ ...styles.drawerContainer, paddingTop: 2 }}>
          <Typography style={styles.drawerHeader}>{article?.magTitle}</Typography>
        </Grid>
        <Box onClick={onEditSaveArticleClicked} style={styles.edit}>
          <EditIcon fontSize={'small'}/>
          <Typography style={styles.drawerSubheader}>&nbsp;{!showDelete ? 'Edit Saved Articles' : 'Finish Editing'}</Typography>
        </Box>
        {(article?.savedArticles || []).map((savedArticle: EntitlementArticle) => (
          <ListItem key={savedArticle.entitlementId}>
            <ListItemButton>
              <ImageListItem key={savedArticle.notes} style={styles.bottomLine}>
                {showDelete && renderDeleteSection(savedArticle)}
                <img
                  onClick={() => openIssue(savedArticle.entitlementId, false, savedArticle.urlArticleId)}
                  style={{ width: '100%', }}
                  srcSet={savedArticle.thumbnailImgUrl}
                  src={savedArticle.thumbnailImgUrl}
                  alt={savedArticle.title}
                  loading="lazy"
                />
                <Box sx={{ p: 0.5 }} />
                <ListItemText
                  disableTypography
                  primary={
                    <>
                      <Typography variant="body1" style={styles.drawerBoldText}>{savedArticle.title}</Typography>
                      <Typography variant="body2" style={styles.drawerSubtitle}>{savedArticle.notes}</Typography>
                      <Box sx={{ p: 1 }} />
                    </>
                  }
                />
              </ImageListItem>
              <Divider />
            </ListItemButton>
            <Divider />
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default DrawerDetails
